import React from 'react'

const Locations = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 30 30"
    fill="none"
  >
    <path
      d="M15 28.125L7.09126 18.7978C6.98136 18.6578 6.87261 18.5168 6.76501 18.375C5.41473 16.5951 4.68499 14.4216 4.68751 12.1875C4.68751 9.45246 5.774 6.82943 7.70797 4.89546C9.64194 2.96149 12.265 1.875 15 1.875C17.7351 1.875 20.3581 2.96149 22.292 4.89546C24.226 6.82943 25.3125 9.45246 25.3125 12.1875C25.3147 14.4206 24.5853 16.5929 23.2359 18.3722L23.235 18.375C23.235 18.375 22.9538 18.7444 22.9116 18.7941L15 28.125ZM8.26219 17.2453C8.26219 17.2453 8.48063 17.5341 8.53032 17.5959L15 25.2263L21.4781 17.5856C21.5194 17.5341 21.7397 17.2425 21.7397 17.2425C22.8433 15.7886 23.4397 14.0129 23.4375 12.1875C23.4375 9.94974 22.5486 7.80362 20.9662 6.22129C19.3839 4.63895 17.2378 3.75 15 3.75C12.7622 3.75 10.6161 4.63895 9.03379 6.22129C7.45145 7.80362 6.56251 9.94974 6.56251 12.1875C6.56019 14.014 7.1573 15.7909 8.26219 17.2453Z"
      fill="#DD7744"
    />
    <path
      d="M19.6875 16.875H17.8125V9.375H12.1875V16.875H10.3125V9.375C10.3125 8.87772 10.51 8.40081 10.8617 8.04918C11.2133 7.69754 11.6902 7.5 12.1875 7.5H17.8125C18.3098 7.5 18.7867 7.69754 19.1383 8.04918C19.49 8.40081 19.6875 8.87772 19.6875 9.375V16.875Z"
      fill="#DD7744"
    />
    <path
      d="M14.0625 15H15.9375V16.875H14.0625V15ZM14.0625 11.25H15.9375V13.125H14.0625V11.25Z"
      fill="#DD7744"
    />
  </svg>
)

export default Locations
